<template>
	<transition 
			appear
			:appear-active-class="$_profile_stylePageAnimation()">
		<template v-if="initialized_">
			<v-container 
					class="customVContainer"
					:style="$_profile_stylePageContainerStyle()"
					fluid>
				<v-row class="customVRow" no-gutters>
					<v-col>
						<v-card color="transparent" flat>
							<v-card-title class="pt-0">
								<v-row justify="center">
									<v-col cols="auto">
										<span class="title">User Information</span>
									</v-col>
								</v-row>
							</v-card-title>
							<v-card-text>
								<template v-for="(contentVals, contentKey) in sortObject($_profile_contents(), 'order')">
									<v-row :key="contentKey">
										<v-col md="2">
											<v-chip	class="caption"
													:color="$_profile_styleChipColor"
													:dark="$_profile_styleChipDark"
													:label="$_profile_styleChipLabel"
													:light="$_profile_styleChipLight"
													:outlined="$_profile_styleChipOutlined"
													:small="$_profile_styleChipSmall"
													:text-color="$_profile_styleChipTextColor"
													v-text="contentVals.title" />
										</v-col>
										<!-- edit button for mobile -->
										<template v-if="$_profile_stateAppIsMobileScreen">
											<v-col cols="auto">
												<v-btn	class="customVBtn"

														:disabled="!contentVals.editable"

														icon
														small
														@click="$_profile_edit(contentVals, contentKey)">
													<v-icon small>edit</v-icon>
												</v-btn>
											</v-col>
										</template>
										<template v-if="contentVals.type == 'uid'">
											<v-col cols="12" md="8">
												<span v-text="$_profile_currentUserUid" />
											</v-col>
										</template>
										<template v-if="contentVals.type == 'text' || contentVals.type == 'postcode'">
											<v-col cols="12" md="8">
												<span v-text="userState_[contentKey]" />
											</v-col>
										</template>
										<template v-if="contentVals.type == 'address'">
											<v-col cols="12" md="8">
												<span v-text="address_" />
											</v-col>
										</template>
										<template v-if="contentVals.type == 'image'">
											<v-col cols="12" md="8" class="center">
												<v-img	class="image_"
														:aspect-ratio="1"
														max-height="150px"
														max-width="150px"
														contain
														:src="userState_.profilePictureUrl" />
											</v-col>
										</template>
										<!-- edit button for mobile -->
										<template v-if="!$_profile_stateAppIsMobileScreen">
											<v-spacer />
											<v-col cols="auto">
												<v-btn	class="customVBtn"

														:disabled="!contentVals.editable"

														icon
														small
														@click="$_profile_edit(contentVals, contentKey)">
													<v-icon small>edit</v-icon>
												</v-btn>
											</v-col>
										</template>
									</v-row>
								</template>
							</v-card-text>
							<v-card-actions>
								<v-row justify="center">
									<v-col cols="12" sm="auto" class="center">
										<v-btn	class="customVBtn"
												:block="$_profile_styleResetPasswordButtonBlock"
												:color="$_profile_styleResetPasswordButtonColor"
												:dark="$_profile_styleResetPasswordButtonDark"
												:depressed="$_profile_styleResetPasswordButtonDepressed"
												:elevation="$_profile_styleResetPasswordButtonElevation"
												:large="$_profile_styleResetPasswordButtonLarge"
												:light="$_profile_styleResetPasswordButtonLight"
												:outlined="$_profile_styleResetPasswordButtonOutlined"
												:rounded="$_profile_styleResetPasswordButtonRounded"
												:small="$_profile_styleResetPasswordButtonSmall"
												:text="$_profile_styleResetPasswordButtonFlat"
												to="/reset-password"
												v-text="$_profile_langResetPassword" />
									</v-col>
									<v-col cols="12" sm="auto" class="center">
										<v-btn	class="customVBtn"
												:block="$_profile_styleSecurityQuestionButtonBlock"
												:color="$_profile_styleSecurityQuestionButtonColor"
												:dark="$_profile_styleSecurityQuestionButtonDark"
												:depressed="$_profile_styleSecurityQuestionButtonDepressed"
												:elevation="$_profile_styleSecurityQuestionButtonElevation"
												:large="$_profile_styleSecurityQuestionButtonLarge"
												:light="$_profile_styleSecurityQuestionButtonLight"
												:outlined="$_profile_styleSecurityQuestionButtonOutlined"
												:rounded="$_profile_styleSecurityQuestionButtonRounded"
												:small="$_profile_styleSecurityQuestionButtonSmall"
												:text="$_profile_styleSecurityQuestionButtonFlat"
												to="/security-question"
												v-text="$_profile_langSecurityQuestion" />
									</v-col>
								</v-row>
							</v-card-actions>
						</v-card>
					</v-col>
				</v-row>
				<v-dialog
						v-model="showDialog_"
						:max-width="$_profile_stateAppIsMobileScreen ? '100vw' : '50vw'"
						persistent>
					<validation-observer v-slot="validation">
						<v-card>
							<v-card-title class="center pt-6">
								<span v-text="dialog_.title" />
							</v-card-title>
							<v-card-text class="py-2">
								<template v-if="dialog_.type == 'image'">
									<template v-if="isFalse(dialog_.value)">
										<validation-provider rules="required">
											<v-file-input
													accept=".jpeg,.jpg,.png"
													hide-details
													label=".jpeg / .jpg / .png"
													outlined
													:prepend-icon="null"
													show-size
													v-model="file_" />
										</validation-provider>
									</template>
									<template v-else>
										<v-row align="center" dense>
											<v-col>
												<v-text-field
														clearable
														hide-details
														outlined
														readonly
														v-model="dialog_.value" />
											</v-col>
											<v-col cols="auto">
												<clipboard-button :text="dialog_.value" />
											</v-col>
										</v-row>
									</template>
								</template>
								<template v-if="dialog_.type == 'text' || dialog_.type == 'postcode'">
									<validation-provider rules="required">
										<v-text-field 
												v-model="dialog_.value"
												hide-details
												outlined
												:placeholder="dialog_.text" />
									</validation-provider>
								</template>
							</v-card-text>
							<v-card-actions class="center">
								<v-row dense justify="center">
									<v-col cols="auto">
										<v-btn	class="customVBtn"

												:disabled="(!validation.passed && !validation.valid) || $_profile_uploadOverSize()"

												@click="$_profile_save(dialog_.key, dialog_.type, dialog_.value)">
											<template v-if="!onProgress_">
												Save
											</template>
											<template v-else>
												<progress-circular />
											</template>
										</v-btn>
									</v-col>
									<v-col cols="auto">
										<v-btn	class="customVBtn"
												@click="$_profile_close()">
											Close
										</v-btn>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-card>
					</validation-observer>
				</v-dialog>
			</v-container>
		</template>
		<template v-else>
			<v-row	class="customVRow">
				<v-col cols="12" class="center">
					<progress-circular />
				</v-col>
			</v-row>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'Profile',
		data() {
			return {
				pageName_: 'profile',
				pageType_: 'profile',

				initialized_: false,

				showDialog_: false,

				onProgress_: false,

				dialog_: {
					key: null,
					title: null,
					text: null,
					type: null,
					value: null
				},

				file_: null,
				address_: null,

				userState_: {}
			}
		},
		computed: {
			// current user
			$_profile_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_profile_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_profile_statePageIsInitialized() {
				const self_ = this;
				const initialized_ = self_.getPageState('isInitialized')
				return initialized_[self_.pageName_]
			},
			// contents / inits
			$_profile_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getPageContents(self_.pageName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_profile_inits() {
				const self_ = this;
				return () => {
					return self_.getPageInits(self_.pageName_)
				}
			},
			// lang
			$_profile_langResetPassword() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_profile_inits(), 'resetPassword')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_profile_langSecurityQuestion() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.$_profile_inits(), 'securityQuestion')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// style
			$_profile_stylePage() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_profile_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_profile_inits(), 'page')
				}
			},
			$_profile_stylePageAnimation() {
				const self_ = this;
				return () => {
					const page_ = self_.$_profile_stylePage()
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.animation)
				}
			},
			$_profile_stylePageContainer() {
				const self_ = this;
				if(self_.isEmpty(self_.$_profile_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_profile_inits(), 'pageContainer')
			},
			$_profile_stylePageContainerStyle() {
				const self_ = this;
				return () => {
					const page_ = self_.$_profile_stylePageContainer;
					if(self_.isFalse(page_)) { return null }
					return self_.getStylesVal(page_.style)
				}
			},
			$_profile_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_profile_inits(), 'chip')
			},
			$_profile_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_profile_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_profile_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_profile_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_profile_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_profile_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_profile_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_profile_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_profile_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_profile_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_profile_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_profile_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_profile_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_profile_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			},
			$_profile_styleResetPasswordButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_profile_inits(), 'resetPasswordButton')
			},
			$_profile_styleResetPasswordButtonBlock() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_profile_styleResetPasswordButtonColor() {
				const self_ = this;
				const button_ =self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_profile_styleResetPasswordButtonDark() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_profile_styleResetPasswordButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_profile_styleResetPasswordButtonElevation() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_profile_styleResetPasswordButtonFlat() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_profile_styleResetPasswordButtonLarge() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_profile_styleResetPasswordButtonLight() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_profile_styleResetPasswordButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_profile_styleResetPasswordButtonRounded() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_profile_styleResetPasswordButtonSmall() {
				const self_ = this;
				const button_ = self_.$_profile_styleResetPasswordButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_profile_styleSecurityQuestionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_profile_inits(), 'securityQuestionButton')
			},
			$_profile_styleSecurityQuestionButtonBlock() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_profile_styleSecurityQuestionButtonColor() {
				const self_ = this;
				const button_ =self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_profile_styleSecurityQuestionButtonDark() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_profile_styleSecurityQuestionButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_profile_styleSecurityQuestionButtonElevation() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_profile_styleSecurityQuestionButtonFlat() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_profile_styleSecurityQuestionButtonLarge() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_profile_styleSecurityQuestionButtonLight() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_profile_styleSecurityQuestionButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_profile_styleSecurityQuestionButtonRounded() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_profile_styleSecurityQuestionButtonSmall() {
				const self_ = this;
				const button_ = self_.$_profile_styleSecurityQuestionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			// file
			$_profile_uploadOverSize() {
				const self_ = this;
				return () => {
					return !self_.isFalse(self_.file_) && (self_.file_.size > 1000000) // 1MB
				}
			}
		},
		created() {
			const self_ = this;
			// life cycle
			self_.createdPage(self_.pageName_)

			self_.$_profile_setPageState()

			if(self_.$_profile_statePageIsInitialized) { 
				self_.initialized_ = true;
			} else {
				self_.$_profile_initialize()
			}
		},
		beforeMount() {
			const self_ = this;
			self_.beforeMountPage(self_.pageName_)

			self_.userState_ = self_.getState('user')
			// get address
			if(!self_.isFalse(self_.userState_.postcode)) {
				self_.$_profile_getAddressByPostcode(self_.userState_.postcode)
			}
		},
		beforeDestroy() {
			const self_ = this;
			self_.beforeDestroyPage(self_.pageName_)
		},
		methods: {
			$_profile_setPageState() {
				const self_ = this;

				self_.setPageState('name', self_.pageName_)
				self_.setPageState('type', self_.pageType_)
			},
			$_profile_initialize() {
				const self_ = this;

				Promise.resolve().then(() => {
					return self_.initializePage(self_.pageName_, self_.pageType_)
				}).then(() => {
					self_.initialized_ = true;
				}).catch(error => {
/* error */			self_.logError('Error', '$_profile_initialize()', error)
				})
			},
			$_profile_edit(contentVals, contentKey) {
				const self_ = this;
				
				self_.dialog_.key = contentKey;
				self_.dialog_.title = contentVals.title;
				self_.dialog_.text = contentVals.text;
				self_.dialog_.type = contentVals.type;

				self_.dialog_.value = self_.userState_[contentKey]

				self_.showDialog_ = true;
			},
			$_profile_save(key, type, value) {
				const self_ = this;
				const router_ = self_.$router;

				if(self_.onProgress_) { return }

				self_.onProgress_ = true;

				const uid_ = self_.$_profile_currentUserUid;

				let body_ = {}

				Promise.resolve().then(() => {
					if(type == 'image') {
						return self_.uploadFileImage('Profile Pictures', uid_, self_.file_)	
					}
					else {
						return Promise.resolve()
					}
				}).then(result => {
					if(type == 'image') {
						body_[key] = result.url;
					} else {
						body_[key] = value;
					}

					if(type == 'postcode') {
						self_.$_profile_getAddressByPostcode(value)
					}

					return self_.updateUser(uid_, body_)
				}).then(() => {
					return self_.initializeUser()
				}).then(() => {
					self_.onProgress_ = false;

					self_.$_profile_close()
				}).catch(error => {
					self_.errorMessage_ = error;
				})
			},
			$_profile_close() {
				const self_ = this;
				
				self_.showDialog_ = false;

				self_.dialog_.key = null;
				self_.dialog_.title = null;
				self_.dialog_.text = null;
				self_.dialog_.type = null;
				self_.dialog_.value = null;

				self_.onProgress_ = false;
			},
			$_profile_getAddressByPostcode(postcode) {
				const self_ = this;

				Promise.resolve().then(() => {
					const body_ = { postcode: postcode }
					return self_.callFunction('geocodingFunction', 'getAddressByPostcode', { body: body_ })
				}).then(result => {
					self_.address_ = result.address;
				})
			}
		}
	}
</script>

<style scoped>
	.card_ {
		padding: 8px 12px;
	}
	.row_ {
		width: 100%;
	}
	.image_ {
		border-radius: 75px !important;
	}
</style>